import { useEffect, useState } from "react"

export const useValidatePassword = (values: { password: string }) => {
	const [validatedPassowrd, setValidatedPassword] = useState({
		lowercase: false,
		numbers: false,
		uppercase: false,
		minimumCharacters: false,
		specialCharacters: false,
	})

	useEffect(() => {
		if (!values?.password) {
			// If password is not defined or empty, set all validations to false.
			setValidatedPassword({
				lowercase: false,
				numbers: false,
				uppercase: false,
				minimumCharacters: false,
				specialCharacters: false,
			})
			return
		}

		const password = values.password
		const regexLowercase = /[a-z]/
		const regexNumber = /\d/
		const regexUppercase = /[A-Z]/
		const regexMinimumCharacters = /^.{8,32}$/
		const regexSpecialCharacters = /[!@#$%^&*()_+=[\]{};':"\\|,.<>/?-]/

		const newPasswordValidationState = {
			lowercase: regexLowercase.test(password),
			numbers: regexNumber.test(password),
			uppercase: regexUppercase.test(password),
			minimumCharacters: regexMinimumCharacters.test(password),
			specialCharacters: regexSpecialCharacters.test(password),
		}

		setValidatedPassword(newPasswordValidationState)
	}, [values])

	return validatedPassowrd
}
